/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { imagesGetApiV3ImagesTransactionsTransactionHashPng } from "../../funcs/imagesGetApiV3ImagesTransactionsTransactionHashPng.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .GetApiV3ImagesTransactionsTransactionHashPngRequest$inboundSchema,
};

export const tool$imagesGetApiV3ImagesTransactionsTransactionHashPng:
  ToolDefinition<typeof args> = {
    name: "images-get-api-v3-images-transactions-transaction-hash-png",
    description: ``,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] =
        await imagesGetApiV3ImagesTransactionsTransactionHashPng(
          client,
          args.request,
          { fetchOptions: { signal: ctx.signal } },
        ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };
